'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

const ScrollToTop: React.FC = () => {
  const [motion, setMotion] = useState<'idle' | 'scrolling'>('idle');
  const t = useTranslations('Components.Footer');

  const handleScrollToTop = () => {
    setMotion('scrolling');
    window.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
      setMotion('idle');
    }, 500);
  };

  return (
    <button
      className="block w-full bg-mom-brandColorDarker px-6 py-4 text-center text-sm text-white text-opacity-70 hover:text-opacity-100 hover:underline data-[motion=idle]:opacity-100 data-[motion=scrolling]:opacity-50"
      data-motion={motion}
      onClick={handleScrollToTop}
    >
      {t('backToTop')}
    </button>
  );
};

export default ScrollToTop;
